import AdminCategoryPageEditor from "@/components/admin/AdminCategoryPageEditor";
export default function AdminPerlengkapanIbadah() {
  return <AdminCategoryPageEditor pageKey="perlengkapan-ibadah" pageTitle="Halaman: Perlengkapan Ibadah" previewPath="/kategori/perlengkapan-ibadah" />;
}
